'use strict';

exports.__esModule = true;
var CITIES_AREAS = exports.CITIES_AREAS = {
  CITIES: {
    LOAD: 'CITIES_LOAD',
    LOAD_DONE: 'CITIES_LOAD_DONE',
    LOAD_FAIL: 'CITIES_LOAD_FAIL'
  },
  AREAS: {
    LOAD: 'AREAS_LOAD',
    LOAD_DONE: 'AREAS_LOAD_DONE',
    LOAD_FAIL: 'AREAS_LOAD_FAIL'
  },
  BRANCHES_AREAS: {
    LOAD: 'BRANCHES_AREAS_LOAD',
    LOAD_DONE: 'BRANCHES_AREAS_LOAD_DONE',
    LOAD_FAIL: 'BRANCHES_AREAS_LOAD_FAIL'
  }
};

var loadCities = exports.loadCities = function loadCities() {
  return {
    type: CITIES_AREAS.CITIES.LOAD
  };
};

var loadAreas = exports.loadAreas = function loadAreas() {
  return {
    type: CITIES_AREAS.AREAS.LOAD
  };
};

var loadBranchesAreas = exports.loadBranchesAreas = function loadBranchesAreas(branchesKeys) {
  return {
    type: CITIES_AREAS.BRANCHES_AREAS.LOAD,
    branchesKeys: branchesKeys
  };
};